export const currencyFormatter = (value: number, currency: string): string =>
  new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  })
    .format(value)
    .replace('US', '');
